/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  AuthorizeRequest,
  AuthorizeResponse,
  HTTPValidationError
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * The URL to send the user to, and the state that will verify their return.
 *
 * BUILT HERE RATHER THAN IN THE BROWSER, and that is the point of this route.
 * Only the server can mint a state it will recognise, keep the PKCE verifier
 * somewhere the browser cannot read, and set `access_type=offline` and
 * `prompt=consent` on Google — two parameters the GIS code client the browser
 * used does not expose at all, which is why reconnecting after a revocation
 * could never obtain a new refresh token.
 * @summary Begin Calendar Authorization
 */
export const beginCalendarAuthorization = (
    provider: string,
    authorizeRequest: AuthorizeRequest,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<AuthorizeResponse>(
      {url: `/calendar/${provider}/authorize`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authorizeRequest, signal
    },
      options);
    }




export const getBeginCalendarAuthorizationMutationKey = () => ['beginCalendarAuthorization'] as const;

export const getBeginCalendarAuthorizationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof beginCalendarAuthorization>>, TError,BeginCalendarAuthorizationMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof beginCalendarAuthorization>>, TError,BeginCalendarAuthorizationMutationVariables, TContext> => {

const mutationKey = getBeginCalendarAuthorizationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof beginCalendarAuthorization>>, BeginCalendarAuthorizationMutationVariables> = (props) => {
          const {provider,data} = props ?? {};

          return  beginCalendarAuthorization(provider,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BeginCalendarAuthorizationMutationResult = NonNullable<Awaited<ReturnType<typeof beginCalendarAuthorization>>>
    export type BeginCalendarAuthorizationMutationBody = AuthorizeRequest
    export type BeginCalendarAuthorizationMutationError = HTTPValidationError
    export type BeginCalendarAuthorizationMutationVariables = {provider: string;data: AuthorizeRequest}

    /**
 * @summary Begin Calendar Authorization
 */
export const useBeginCalendarAuthorization = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof beginCalendarAuthorization>>, TError,BeginCalendarAuthorizationMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof beginCalendarAuthorization>>,
        TError,
        BeginCalendarAuthorizationMutationVariables,
        TContext
      > => {
      return useMutation(getBeginCalendarAuthorizationMutationOptions(options));
    }
